import { OFF, ON } from "../config/constants"
export const DEFAULT_NUMBER_OF_CHOICES = 2

export function boolToOnOff(v: boolean): OnOff {
  return v ? ON : OFF
}

export function onOffToBool(v: OnOff): boolean {
  return v === ON
}

export const initialAppSettings: AppSettings = {
  dontHitIt: {
    count: 1,
    maxNumberOfQuestions: 60,
    source: "bookmarks",
  },
  gutenberg: {
    speed: 350,
  },
  haveYouSeenIt: {
    hideErrorNotification: OFF,
    intervalIsFullySeen: ON,
    isSameAsPreviousMode: OFF,
    poemsNumberOfRepeats: 2,
    reviewMode: OFF,
    smallerText: OFF,
    source: "none",
    speed: 1,
  },
  index: {
    amerika: 0,
    gutenbergDe: 0,
    gutenbergFr: 0,
    prozess: 0,
    quotes: 0,
    revealIt: 0,
    revealIt_bookmarks: 0,
    revealIt_coreBookmarks: 0,
    revealIt_pairOfWord: 0,
    translateIt: 0,
    urtail: 0,
  },
  randomWords: {
    filterByNumberOfWords: OFF,
    numberOfLines: 2,
    randomCombinationMode: ON,
  },
  rememberSequence: {
    source: "bookmarks",
    wordsPerSet: 4,
  },
  revealIt: {
    maxNumberOfQuestions: 20,
    revealEndOfWord: ON,
    source: "bookmarks",
    speed: 1200,
  },
  selectCorrect: {
    index: {},
    rule: "",
  },
  selectCorrectWord: {
    book: "quotes",
    hardMode: OFF,
    limitQuestionsMode: OFF,
    numberOfChoices: DEFAULT_NUMBER_OF_CHOICES,
    readAsBookMode: OFF,
  },
  shared: {
    acceptMicInputOnInit: OFF,
    autoListen: OFF,
    goToNextOnSuccess: OFF,
    goToNextWaitingTime: 1.5,
    privateData: OFF,
    speakAppLanguage: "french",
    speakWhenHandsFree: OFF,
  },
  shortSentences: {
    index: 0,
    mode: "literature-non-questions" satisfies ShortSentencesMode,
  },
  sortaballs: {
    style: "6",
    variant: "circle",
  },
  speedReader: {
    abTesting:OFF,
		altMode: OFF,
    bookIndex: "1",
    focusedChars: ON,
    progress: {},
    speed: 350,
    totalItems: 0,
    waveMode: OFF,
  },
}
